import { $t } from '@/locales'
/* eslint-disable */
function padLeftZero(str) {
  return `00${str}`.substr(str.length)
}
export function compareVersion(version1, version2) {
  const arr1 = version1.split('.')
  const arr2 = version2.split('.')
  const length1 = arr1.length
  const length2 = arr2.length
  const minlength = Math.min(length1, length2)
  let i = 0
  for (i; i < minlength; i++) {
    const a = parseInt(arr1[i])
    const b = parseInt(arr2[i])
    if (a > b) {
      return 1
    } else if (a < b) {
      return -1
    }
  }
  if (length1 > length2) {
    for (let j = i; j < length1; j++) {
      if (parseInt(arr1[j]) != 0) {
        return 1
      }
    }

    return 0
  } else if (length1 < length2) {
    for (let j = i; j < length2; j++) {
      if (parseInt(arr2[j]) != 0) {
        return -1
      }
    }

    return 0
  }

  return 0
}

// 获取url参数
export function getQueryStrings() {
  const url = window.location.search
  const theRequest = {}
  if (url.indexOf('?') !== -1) {
    const str = url.substr(1)
    const strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }

  return theRequest
}

/**
 * 存储 localStorage
 */
export const setStore = (name, content, expired) => {
  if (!name) {
    return
  }

  let source = ''
  if (expired) {
    source = JSON.stringify({
      data: content,
      _time_: Date.now() + expired,
    })
  } else {
    source = typeof content !== 'string' ? JSON.stringify(content) : content
  }

  window.localStorage.setItem(name, source)
}

/**
 * 获取 localStorage
 */
export const getStore = name => {
  if (!name) return

  const source = JSON.parse(window.localStorage.getItem(name))
  if (!source) return source

  // 如果过期，则清空并返回空
  // eslint-disable-next-line no-underscore-dangle
  if (source._time_) return Date.now() >= source._time_ ? removeStore(name) : source.data

  return source
}

/**
 * 删除 localStorage
 */
export const removeStore = name => {
  if (!name) return

  return window.localStorage.removeItem(name)
}

export const REGEXP = {
  // 验证手机号码
  REGEXP_PHONE(num) {
    return /^1[3456789]\d{9}$/.test(num)
  },

  // 验证邮箱
  REGEXP_EMAIL(addr) {
    return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/.test(addr)
  },

  // 验证姓名
  REGEXP_NAME(name) {
    return /^[a-zA-Z0-9\u4e00-\u9fa5]+$/.test(name)
  },
}

export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length))
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  }
  // eslint-disable-next-line no-restricted-syntax
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = `${o[k]}`
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
    }
  }

  return fmt
}

export function formatUtc(utcTime, accuracy) {
  if (accuracy === 'month') {
    return formatDate(new Date(utcTime), 'yyyy-MM').split(' ')[0]
  }
  if (accuracy === 'day') {
    if (utcTime) {
      return formatDate(new Date(utcTime), 'yyyy-MM-dd hh:mm:ss').split(' ')[0]
    }

    return ''
  } else if (accuracy === 'hour') {
    if (utcTime) {
      return formatDate(new Date(utcTime), 'yyyy-MM-dd hh:mm:ss').split(' ')[1]
    }

    return formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss').split(' ')[1]
  }
  if (utcTime) {
    return formatDate(new Date(utcTime), 'yyyy-MM-dd hh:mm:ss')
  }

  return formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss')
}

export function getQueryStringArgs(url) {
  url = url === null ? window.location.href : url
  const qs = url.substring(url.lastIndexOf('?') + 1)
  const args = {}
  const items = qs.length > 0 ? qs.split('&') : []
  let item = null
  let name = null
  let value = null
  for (let i = 0; i < items.length; i += 1) {
    item = items[i].split('=')

    // 用decodeURIComponent()分别解码name 和value（因为查询字符串应该是被编码过的）。
    name = decodeURIComponent(item[0])
    value = decodeURIComponent(item[1])

    if (name.length) {
      args[name] = value
    }
  }

  return args
}

/**
 *
 * 涉及到展示余量的地方都需要使用该方法转换：
 * 单位的使用场景参考：
 * http://wiki.timevale.cn:8081/pages/viewpage.action?pageId=135728012
 * @param {数据对象} item
 * @param {price的key值} key
 * @param {需要转换成的单位} needUnit
 * @param {
 * G :1 - 整数， 2 -向上取整， 0 - 保留两位小数;
 * KB:1 - 超过1024*1024KB进到G, 0 -不足1KB，则不显示，当大于等于1KB显示消费记录
 * } digitalFormat
 * @returns
 */
export function getShowPrice(item, key, needUnit, digitalFormat) {
  if (item.giftType !== 2) {
    // 不是赠送时间
    if (item.saleType === 2) {
      // 赠送充值式
      return (item[key] / 10000).toFixed(2)
    } else if (item.units === 'G') {
      switch (needUnit) {
        case 'KB':
          if (digitalFormat === 1) {
            if (item[key] >= 1024 * 1024 * 1024) {
              return getShowPrice(item, key, 'G')
            }

            return (item[key] / 1024).toFixed(2)
          }

          return item[key] < 1024 ? '-' : (item[key] / 1024).toFixed(2)
        case 'MB':
          return (item[key] / 1024 / 1024).toFixed(2)
        case 'G':
          if (digitalFormat === 1) {
            return parseInt(item[key] / 1024 / 1024 / 1024)
          } else if (digitalFormat === 2) {
            return Math.ceil(item[key] / 1024 / 1024 / 1024)
          }

          return (item[key] / 1024 / 1024 / 1024).toFixed(2)

        default:
          return item[key]
      }
    } else {
      return item[key] || 0
    }
  } else {
    return item[key] || 0
  }
}

/**
 *
 * 涉及到展示余量的地方都需要使用该方法转换：
 * 单位的使用场景：
 * http://wiki.timevale.cn:8081/pages/viewpage.action?pageId=135728012
 * @param {数据对象} item
 * @param {需要转换成的单位} units
 * @param {数据格式 1-超过1024*1024KB进到G} digitalFormat
 * @param {getShowPrice的取值} key
 * @returns
 */
export function getShowUnit(item, units, digitalFormat, key) {
  if (item.giftType === 2) {
    return $t('天')
  } else if (item.saleType === 2) {
    return $t('元')
  } else if (units && item.units === 'G') {
    if (units === 'KB' && digitalFormat === 1) {
      if (item[key] >= 1024 * 1024 * 1024) {
        return 'G'
      }
    }

    return units
  }

  return item.units
}

export function browserRedirect() {
  const sUserAgent = navigator.userAgent.toLowerCase()
  const bIsIpad = sUserAgent.match(/ipad/i) === 'ipad'
  const bIsIphoneOs = sUserAgent.match(/iphone os/i) === 'iphone os'
  const bIsMidp = sUserAgent.match(/midp/i) === 'midp'
  const bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) === 'rv:1.2.3.4'
  const bIsUc = sUserAgent.match(/ucweb/i) === 'ucweb'
  const bIsAndroid = sUserAgent.match(/android/i) === 'android'
  const bIsCE = sUserAgent.match(/windows ce/i) === 'windows ce'
  const bIsWM = sUserAgent.match(/windows mobile/i) === 'windows mobile'

  if (!(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM)) {
    return false
  }

  return true
}

function _utf8_decode(utftext) {
  let string = ''
  let i = 0
  let c = 0
  let c2 = 0
  while (i < utftext.length) {
    c = utftext.charCodeAt(i)
    if (c < 128) {
      string += String.fromCharCode(c)
      i++
    } else if (c > 191 && c < 224) {
      c2 = utftext.charCodeAt(i + 1)
      string += String.fromCharCode(((c & 31) << 6) | (c2 & 63))
      i += 2
    } else {
      c2 = utftext.charCodeAt(i + 1)
      c3 = utftext.charCodeAt(i + 2)
      string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63))
      i += 3
    }
  }

  return string
}
export function base64Decode(input) {
  let output = ''
  const _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
  let chr1
  let chr2
  let chr3
  let enc1
  let enc2
  let enc3
  let enc4
  let i = 0
  input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '')
  while (i < input.length) {
    enc1 = _keyStr.indexOf(input.charAt(i++))
    enc2 = _keyStr.indexOf(input.charAt(i++))
    enc3 = _keyStr.indexOf(input.charAt(i++))
    enc4 = _keyStr.indexOf(input.charAt(i++))
    chr1 = (enc1 << 2) | (enc2 >> 4)
    chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
    chr3 = ((enc3 & 3) << 6) | enc4
    output += String.fromCharCode(chr1)
    if (enc3 !== 64) {
      output += String.fromCharCode(chr2)
    }
    if (enc4 !== 64) {
      output += String.fromCharCode(chr3)
    }
  }
  output = _utf8_decode(output)

  return output
}

export function debounce(func, wait, immediate) {
  let timeout
  let result

  return function (...args) {
    const context = this
    if (timeout) clearTimeout(timeout)
    if (immediate) {
      // 如果已经执行过，不再执行
      const callNow = !timeout
      timeout = setTimeout(() => {
        timeout = null
      }, wait)
      if (callNow) result = func.apply(context, args)
    } else {
      timeout = setTimeout(() => {
        func.apply(context, args)
      }, wait)
    }

    return result
  }
}

/**
 * 数字、价格运算
 * Jianyi 2019-12-10 17:59:41
 * @export
 * @returns
 */
export const numberCal = {
  // 加法运算
  add(a, b) {
    let c, d, e
    try {
      c = a.toString().split('.')[1].length
    } catch (f) {
      c = 0
    }
    try {
      d = b.toString().split('.')[1].length
    } catch (f) {
      d = 0
    }

    return (e = Math.pow(10, Math.max(c, d))), (this.mul(a, e) + this.mul(b, e)) / e
  },

  // 减法运算
  sub(a, b) {
    let c, d, e
    try {
      c = a.toString().split('.')[1].length
    } catch (f) {
      c = 0
    }
    try {
      d = b.toString().split('.')[1].length
    } catch (f) {
      d = 0
    }

    return (e = Math.pow(10, Math.max(c, d))), (this.mul(a, e) - this.mul(b, e)) / e
  },

  // 乘法运算
  mul(a, b) {
    let c = 0,
      d = a.toString(),
      e = b.toString()
    try {
      c += d.split('.')[1].length
    } catch (f) {}
    try {
      c += e.split('.')[1].length
    } catch (f) {}

    return (Number(d.replace('.', '')) * Number(e.replace('.', ''))) / Math.pow(10, c)
  },

  // 除法运算
  div(a, b) {
    let c,
      d,
      e = 0,
      f = 0
    try {
      e = a.toString().split('.')[1].length
    } catch (g) {}
    try {
      f = b.toString().split('.')[1].length
    } catch (g) {}

    return (c = Number(a.toString().replace('.', ''))), (d = Number(b.toString().replace('.', ''))), this.mul(c / d, Math.pow(10, f - e))
  },
}

// 存证类产品 流量计费展示 传入byte
// ceil 向上取值  floor向下取值
export function showDataUnit(data = 0, type = 'floor', item) {
  const KBYTE = 1024
  const MBYTE = KBYTE * KBYTE
  const GBYTE = KBYTE * MBYTE
  let handleData = null
  type === 'floor' ? (handleData = data => Math.floor(data)) : (handleData = data => Math.ceil(data))
  let unitName = 'B'
  let unitValue = data
  if (Number(unitValue) === 0 || isNaN(Number(unitValue))) {
    return '0.00B'
  }
  if (Math.abs(data) < KBYTE) {
    unitValue = handleData(data)
    unitName = 'B'
  } else if (Math.abs(data) >= KBYTE && Math.abs(data) < MBYTE) {
    unitName = 'K'
    unitValue = handleData(numberCal.div(data, KBYTE) * 100) / 100
  } else if (Math.abs(data) >= MBYTE && Math.abs(data) < GBYTE) {
    unitValue = handleData(numberCal.div(data, MBYTE) * 100) / 100
    unitName = 'M'
  } else if (Math.abs(data) >= GBYTE) {
    unitValue = handleData(numberCal.div(data, GBYTE) * 100) / 100
    unitName = 'G'
  }
  if (item && item.giftType === 2) {
    unitName = $t('天')
    unitValue = data
  } else if (item && item.saleType === 2) {
    unitName = $t('元')
    unitValue = data
  }

  return unitName === $t('天') || unitName === $t('元') ? unitValue + unitName : Number(unitValue).toFixed(2) + unitName
}

/**
 * 统一处理性能上报数据
 * @param {页面字段} init_scene
 * @returns 性能数据
 */
export function getTimingData(init_scene) {
  const { timing } = window.performance

  return {
    init_scene, // 页面名称
    page_route: window.location.href, // 当前页面地址
    client_type: 'WEB',
    connect_process_time: timing.domainLookupEnd - timing.domainLookupStart + timing.connectEnd - timing.connectStart,
    DOM_process_time: timing.domInteractive - timing.domLoading,
    DOM_data_load_time: timing.domComplete - timing.domInteractive,
    resources_load_time: timing.domComplete - timing.domInteractive + timing.responseEnd - timing.requestStart,
    whiteScreen_time: timing.loadEventEnd - timing.fetchStart,
  }
}
// 获取UA
export function getUA() {
  return navigator.userAgent.toLowerCase()
}
// 支付宝
export function isAlipay() {
  return getUA().indexOf('alipayclient') !== -1
}
// 加载aliSDK
function loadAliSDK() {
  return new Promise(resolve => {
    if (window.my) return resolve(window.my)
    const script = document.createElement('script')
    script.onload = () => resolve(window.my)
    // 某些支付宝版本浏览器内可能加载失败
    script.onerror = () => resolve()
    script.src = 'https://appx/web-view.min.js'
    document.getElementsByTagName('head')[0].appendChild(script)
  })
}

// 检测是否在支付宝小程序
export function detectAliMini() {
  // 标记 getEnv 方法的回调是否执行
  let called = false
  try {
    if (!isAlipay()) return Promise.resolve(false)

    return loadAliSDK().then(my => {
      return new Promise(resolve => {
        if (!my) return resolve(false)
        my.getEnv(res => {
          called = true
          resolve(res.miniprogram)
        })

        setTimeout(() => {
          if (called) return
          // 如果 getEnv 方法的回调未执行则默认返回不是小程序内
          resolve(false)
        }, 4000)
      })
    })
  } catch (error) {
    return Promise.resolve(false)
  }
}

/**
 * 判断是否有权限
 * @param {*} list
 * @param {*} options
 * @returns
 */
export function hasPower(list, options) {
  const { fun, subFun } = options || {}
  if (list && list.length > 0) {
    // 管理员 任何权限都有
    const hasAllPower = list.some(item => item.targetClassKey === 'ADMIN' || item.targetClassKey === 'ORGAN_LEGAL')
    if (hasAllPower) return true

    // 循环查询 是否有权限
    return list.some(item => item.targetClassKey === fun && item.operationPermit === subFun)
  }
  return true
}
